import { type ReactElement, useMemo, useReducer } from 'react';

import ModalActionsContext from './ModalActionsContext';
import ModalContext from './ModalContext';
import { applyAction, createActionFunctions } from './reducer';
import { type State } from './types';

const initialState: State = {
    modals: [],
};

type Props = { children: ReactElement };
const ModalProvider = ({ children }: Props) => {
    const [state, dispatch] = useReducer(applyAction, initialState);
    const actions = useMemo(() => createActionFunctions(dispatch), []);

    return (
        <ModalContext value={state}>
            <ModalActionsContext value={actions}>
                {state.modals.map((modal) => {
                    const ModalComponent = modal.component;

                    return (
                        <ModalComponent
                            key={modal.id}
                            {...modal.props}
                            onClose={() => {
                                actions.hide(modal.id);

                                modal.props.onClose?.();
                            }}
                        />
                    );
                })}

                {children}
            </ModalActionsContext>
        </ModalContext>
    );
};

export default ModalProvider;
